import { h } from 'preact'
export const ArrowLeft = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g>
          <path fill="#766A3A" d="m8,16L0,8,8,0l1.43,1.4L3.82,7h12.18v2H3.82l5.6,5.6-1.43,1.4Z"/>
        </g>
      </svg>
    )
}
